import { render, staticRenderFns } from "./TextBoxInputMethodSelector.vue?vue&type=template&id=113884df&scoped=true&"
import script from "./TextBoxInputMethodSelector.vue?vue&type=script&lang=ts&"
export * from "./TextBoxInputMethodSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113884df",
  null
  
)

export default component.exports